import { Routes } from '@angular/router';

import { environment } from '../www/environments/environment';

const mainRoutes: Routes = [
   /*{
      path: '',
      component: MainPage,
      children: [
         //{ path: '', loadComponent: () => import('../apps/main/pages/Home').then(m => m.HomePage) },
         //{ path: 'about', loadComponent: () => import('../apps/main/pages/About').then(m => m.AboutPage) },
         
      ]
   },*/
   { path: '', loadComponent: () => import('../apps/base/Home').then(m => m.EmptyHome) },
   { path: 'login', loadComponent: () => import('../apps/base/EasyLoginComponent').then(m => m.EasyLoginComponent) },
   { path: 'mainedit', loadComponent: () => import('../apps/mainedit/MainEditor').then(m => m.DLMainEditor) },
   { path: 'dlsd001', loadComponent: () => import('../apps/base/dreamloomdev/tests/DreamLoomSceneDemo001').then(m => m.DreamLoomSceneDemo0001) },
   { path: 'dldocstest01', loadComponent: () => import('../apps/base/dreamloomsdocs/DocsTest').then(m => m.DocsTests) },


   // Rotta di errore
   //{ path: '**', loadComponent: () => import('../apps/main/Error').then(m => m.ErrorPage) }

];

const devRoutes: Routes = [

   //Test Components
   //{ path: 'test-cmp-webplatformapi', loadComponent: () => import('../apps/tests/T001_WebPlatformAPITest').then(m => m.WebPlatformAPITest) }, 
   // { path: 'playlists/:playlist', loadComponent: () => import('../apps/playlists/PlaylistApp').then(m => m.PlaylistApp) },
   // { path: 'playlists', loadComponent: () => import('../apps/playlists/PlaylistsMain').then(m => m.PlaylistMain) },
];

const testRoutes: Routes = [

   //Test Components
   //{ path: 'test-cmp-webplatformapi', loadComponent: () => import('../apps/tests/T001_WebPlatformAPITest').then(m => m.WebPlatformAPITest) },
   //{ path: 'test-cmp-database', loadComponent: () => import('../apps/tests/T000_DatabaseTest').then(m => m.DatabaseTest) }, 


];

export const routes: Routes = [
   ...(environment.TEST_ROUTES ? testRoutes : []),
   ...(environment.TEST_ROUTES ? devRoutes : []),
   ...mainRoutes,
] 